import { inject as injectBranding } from '@angular/core';
import { SiteBrandingService } from '../../services/site-branding.service';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';

import { RouterModule } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

type OrderService =
  | 'mcdonalds'
  | 'doordash'
  | 'ubereats';

type DeviceType =
  | 'ios'
  | 'android'
  | 'desktop';


@Component({
  selector: 'app-header',
  imports: [RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  changeDetection: ChangeDetectionStrategy.Default
})
export class HeaderComponent implements OnInit, OnDestroy {
  readonly branding = injectBranding(SiteBrandingService);

  constructor(
    protected readonly authService: AuthService
  ) {}

  lastScrollTop = 0;
  isVisible = true;
  mobileMenuOpen = false;

  @Input() showAdminButton = false;
  @Output() adminToggle = new EventEmitter<void>();

  get logoSrc(): string { return this.branding.logoUrl(); }

  ngOnInit(): void {}
  ngOnDestroy(): void {}

  @HostListener('window:scroll', [])
  onWindowScroll(): void {

    const st =
      window.scrollY ||
      document.documentElement.scrollTop;

    this.isVisible =
      st <= this.lastScrollTop;

    this.lastScrollTop =
      st <= 0
        ? 0
        : st;
  }


  onAdminClick(): void {
    this.adminToggle.emit();
  }


  toggleMobileMenu(): void {
    this.mobileMenuOpen = !this.mobileMenuOpen;

    document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : '';
  }

  closeMobileMenu(): void {
    this.mobileMenuOpen = false;
    document.body.style.overflow = '';
  }


  getOrderLink(
    service: OrderService
  ): string {

    const device =
      this.getDeviceType();

    const links:
      Record<
        OrderService,
        Record<DeviceType, string>
      > = {

      mcdonalds: {

        ios:
          'https://apps.apple.com/us/app/mcdonalds/id922103212',

        android:
          'https://play.google.com/store/apps/details?id=com.mcdonalds.app',

        desktop:
          'https://www.mcdonalds.com/us/en-us/download-app.html'
      },


      doordash: {

        ios:
          'https://apps.apple.com/us/app/doordash-food-grocery-more/id719972451',

        android:
          'https://play.google.com/store/apps/details?id=com.dd.doordash',

        desktop:
          'https://www.doordash.com/'
      },


      ubereats: {

        ios:
          'https://apps.apple.com/us/app/uber-eats-food-groceries/id1058959277',

        android:
          'https://play.google.com/store/apps/details?id=com.ubercab.eats',

        desktop:
          'https://www.ubereats.com/'
      }

    };

    return links[service][device];
  }


  private getDeviceType(): DeviceType {

    const userAgent =
      navigator.userAgent ||
      navigator.vendor;

    if (
      /iPad|iPhone|iPod/i.test(userAgent)
    ) {
      return 'ios';
    }

    if (
      /android/i.test(userAgent)
    ) {
      return 'android';
    }

    return 'desktop';
  }
}
